import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmItemListItemModule} from '../sm-item-list-item/sm-item-list-item.module';
import {SmGlobalSearchItemResultComponent} from './sm-global-search-item-result.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SmItemListItemModule,
  ],
  declarations: [SmGlobalSearchItemResultComponent],
  exports: [SmGlobalSearchItemResultComponent],
})
export class SmGlobalSearchItemResultModule {}
